import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { baseStyles } from "../../utils/baseStyles";
import { asNumberString } from "../../utils/formatters";
import ReactTooltip from "react-tooltip";

function HorizontalStackBarChart({
  currencySymbol = "",
  toolTipMoney = "Amount of Month to Date Revenue per Referral Source",
  colors = ["#0099ce", "#ff664e", "#f5967b", "#42b77a", "#77818e"],
  data = []
}) {
  if (Array.isArray(data) && data.length > 0) {
    let totalAttendees = 0;
    data.map((attendanceType) => (totalAttendees += attendanceType.attendanceValue));
    return (
      <div style={styles.container} data-testid="horizontalStackBarChart">
        <ReactTooltip />
        <div style={styles.flexContainer}>
          {data.map((item, index) => {
            const percent = (item.percent * 100).toFixed(1);
            const finalPercent = percent.toString().split(".");
            return (
              <div
                data-testid="horizontalStackBarChartSection"
                data-tip={
                  item.attendanceValue + " of " + totalAttendees + " (" + finalPercent + "%)"
                }
                key={index}
                style={{
                  flexBasis: finalPercent[0] + "%",
                  textAlign: "center",
                  backgroundColor: colors[index],
                  padding: "5px 0",
                  fontSize: "12px",
                  fontWeight: "700"
                }}
              >
                {finalPercent + "%"}
              </div>
            );
          })}
        </div>
        <div
          style={{
            margin: "20px 0"
          }}
        >
          {data.map((item, index) => {
            const numberString = asNumberString(item.value);
            const number = numberString.split(".");

            return (
              <div
                key={index}
                style={{
                  display: "inline-block",
                  padding: "0 15px"
                }}
              >
                <div
                  data-testid="horizontalStackBarChartLine"
                  style={{
                    width: "30px",
                    height: "5px",
                    backgroundColor: colors[index],
                    display: "block",
                    marginBottom: "3px"
                  }}
                />
                <h5 style={styles.category}>{item.name}</h5>
                <p
                  data-tip={toolTipMoney}
                  data-testid="horizontalStackBarChartValue"
                  style={{
                    color: colors[index],
                    fontSize: "24px",
                    fontWeight: "200",
                    margin: "0"
                  }}
                >
                  {currencySymbol}
                  {number[0]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return <div className="error error-medium">No data for chart</div>;
}

var styles = {
  flexContainer: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row"
  },
  container: {
    fontFamily: "Open Sans, Arial"
  },
  category: baseStyles.categoryTitle
};

export default HorizontalStackBarChart;

HorizontalStackBarChart.propTypes = {
  data: PropTypes.array,
  colors: PropTypes.array,
  currencySymbol: PropTypes.string.isRequired,
  toolTipMoney: PropTypes.string
};
